module.exports = __webpack_public_path__ + "img/اداری-و-سازمانی.38ff2eb3.png";